import React from 'react';
import { Link } from 'react-router-dom';
import  PRETTY from '../../assets/img/logo/PRETTYLASHED.png';

import CartCounter from '../Cart/CartCounter';

const HeaderNav = () => (
  <div className="nav-container">
    <nav className="primary-nav light">
      <Link to="/products">Products</Link>
      <Link to="/styles">Styles</Link>
      <Link to="/gallery">Gallery</Link>
      <Link to="/about">About</Link>
    </nav>
    <div className="logo light">
      <Link to="/" className="logo-link">
        <span className="hide-content">Pretty & Lashed by Shanise</span>
        <div className="big-logo" aria-hidden="true">
          <img
            className="small-logo"
            src="img/logo/ill-short-dark.svg"
            alt="Pretty & Lashed by Shanise logo"
            aria-hidden="true"
          />
          <img alt="Shanise the founder" src={PRETTY} />
        </div>
      </Link>
    </div>
    <nav className="secondary-nav light">
      <CartCounter />
    </nav>
  </div>
);

export default HeaderNav;



// WEBPACK FOOTER //
// ./src/components/global/HeaderNav.js